import type { Gorev } from "./api";

/**
 * BUGÜNÜN ÖZETİ — F-STV-10 ilerlemesi, F-SCH-09 oranı
 *
 * ================================================================
 * NEDEN AYRI BİR SAF MODÜL
 * ================================================================
 * Bu hesap 04.09.2026'ya kadar `Uygulama.tsx` içinde, çizimin
 * ortasında duran üç satırdı ve **yanlıştı** — ama yanlışlığı hiçbir
 * test göremiyordu, çünkü `Uygulama` bir ekran ve ekranın testi yoktu.
 * Kural buraya alındı: altyapısız, tek bir iddia ile sınanabiliyor.
 *
 * ================================================================
 * MAZERETLİ GÖREV PAYDADAN DÜŞER
 * ================================================================
 * Şartname F-SCH-09: "tatil / mazeret günü işaretlenir — o gün
 * tamamlama oranına dahil edilmez." Sunucuda aynı kural
 * `program-kural.ts` → `tamamlamaOrani` içinde yazılı ve gerekçesi
 * orada şöyle: *"paydada bırakıp payda saymamak, hasta olan öğrenciyi
 * cezalandıran bir oran üretirdi."*
 *
 * Kahraman tam olarak onu yapıyordu: payda bütün görevleri sayıyordu,
 * pay yalnızca `COMPLETED` olanları. Mazeretli görev **tamamlanamaz** —
 * `GorevKarti` onun işlem şeridini hiç çizmiyor. Yani hastalandığı için
 * iki görevi mazeretli işaretlenen öğrenci halkasını asla dolduramıyor,
 * "2 görev kaldı" okuyor ve kapatabileceği hiçbir görev bulamıyordu.
 *
 * ================================================================
 * SORU SAYACININ İKİ YANI AYNI KÜMEDEN
 * ================================================================
 * Pay bütün görevlerden, payda yalnızca hedefi olanlardan toplanıyordu.
 * Hedefsiz bir görevde 100 soru çözen öğrenci "150 / 50" görüyordu.
 * İkisi de artık **hedefi olan, mazeretsiz** görevlerden.
 */
export interface GunlukOzet {
  /** Tamamlanan görev sayısı — mazeretliler hariç */
  tamamlanan: number;
  /** Sayılan görev sayısı — mazeretliler hariç */
  toplam: number;
  /**
   * Mazeretli görev sayısı.
   *
   * Paydadan düşüyor ama YOK SAYILMIYOR: kart listesinde duruyorlar ve
   * ekranın onları görmezden gelmesi "planlanmış görev yok" gibi
   * çelişkili bir cümleye yol açıyor. Sunucudaki `tamamlamaOrani` da
   * `mazeretli`yi ayrıca döndürüyor, aynı sebeple.
   */
  mazeretli: number;
  cozulenSoru: number;
  hedefSoru: number;
}

export function gunlukOzet(gorevler: readonly Gorev[]): GunlukOzet {
  const sayilan = gorevler.filter((g) => !g.isExcused);
  const hedefli = sayilan.filter((g) => g.targetQuestionCount !== null);

  return {
    tamamlanan: sayilan.filter((g) => g.gosterilecekDurum === "COMPLETED").length,
    toplam: sayilan.length,
    mazeretli: gorevler.length - sayilan.length,
    cozulenSoru: hedefli.reduce(
      (t, g) => t + (g.correctCount ?? 0) + (g.wrongCount ?? 0) + (g.emptyCount ?? 0),
      0,
    ),
    hedefSoru: hedefli.reduce((t, g) => t + (g.targetQuestionCount ?? 0), 0),
  };
}
